<template>
  <div class="emh-ui-multiselect-group">
    <ui-select-button
      v-for="option in options"
      :key="option.key"
      v-bind="option"
      :data-test-id="`emh-ui-multiselect-group__select-${option.key}-button`"
      @select="selectOption"
    />
  </div>
</template>

<script lang="ts">
export default { name: 'UiMultiselectGroup' };
</script>

<script lang="ts" setup>
import { PropType } from 'vue';
import { MultiselectGroupOption } from './MultiselectGroup.model';
import UiSelectButton from '../selectButton/SelectButton.vue';

defineProps({
  options: { type: Array as PropType<MultiselectGroupOption[]>, default: () => [] },
});

const emit = defineEmits(['select-option']);

const selectOption = (option: MultiselectGroupOption) => emit('select-option', option);
</script>

<style lang="scss" scoped>
.emh-ui-multiselect-group {
  display: grid;
  grid-template-columns: auto;
  grid-gap: var(--wb-spacing-xs);
}
</style>
